export enum TipoReembolso {
    CONSULTA = 1,
    MEDICAMENTO,
    INSTRUMENTACAO_CIRURGICA,//instrumentação?
    ODONTOLOGIA,
    DESPESAS_HOSPITALARES_ELETIVO,
    DESPESAS_HOSPITALERES_URGENCIA,
    TERAPIAS,
    EXAMES,
    HONORARIOS_MEDICOS
}
